import { Box, Typography } from "@mui/material";
import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AssetThumbnailPlaceholder } from "../../../common/assets/img/vectors/asset-thumbnail-placeholder-lg.svg";
import Button from "../../../common/components/Button";
import { useTheme } from "../../../common/contexts/ThemeContext";
import { resolveImageUrl } from "../../../common/utils/imageUrl";

const MediaStep = ({ thumbnail, previewImage, handleImageChange, loading }) => {
  const { t } = useTranslation("assets");
  const { colors } = useTheme();

  const getCurrentImageUrl = () => {
    if (previewImage) return previewImage;
    if (thumbnail) {
      return resolveImageUrl(thumbnail);
    }
    return null;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Typography variant="h4">{t("editModal.assetThumbnail")}</Typography>

      {/* Image Preview */}
      <Box
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          overflow: "hidden",
          aspectRatio: "16/9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "grey.50",
          maxWidth: 400,
          mx: "auto",
        }}
      >
        {getCurrentImageUrl() ? (
          <img
            src={getCurrentImageUrl()}
            alt="Asset Thumbnail"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <AssetThumbnailPlaceholder
            style={{
              width: 80,
              height: 80,
              opacity: 0.5,
              fill: colors.secondary,
            }}
          />
        )}
      </Box>

      {/* Upload Button */}
      <Button
        variant="secondary"
        component="label"
        startIcon={<Upload size={18} />}
        disabled={loading}
        sx={{ maxWidth: 400, mx: "auto" }}
      >
        {t("editModal.uploadNewImage")}
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          hidden
        />
      </Button>
    </Box>
  );
};

export default MediaStep;
